import { AfterViewInit, CSP_NONCE, ChangeDetectorRef, Component, ElementRef, Inject, Input, NgZone, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router, UrlSegment } from '@angular/router';
import { Subscription } from 'rxjs';
import { DeviceService } from 'src/app/services/device.service';
import { Error429Service } from 'src/app/services/error429.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { UserService } from 'src/app/services/user.service';

import { environment } from '../../../../environments/environment';
import { MapService } from 'src/app/services/map.service';
import { ToastrService } from 'ngx-toastr';
interface Clientes{
  value: number;
  name: string;
}
interface Cervezas{
  value: number;
  name: string;
}
interface Estados{
  value: number;
  name: string;
}
@Component({
  selector: 'app-agregar-establecimiento',
  templateUrl: './agregar-establecimiento.component.html',
  styleUrls: ['./agregar-establecimiento.component.css']
})
export class AgregarEstablecimientoComponent {

  //MAPA
  lat: number = 43.0081016;
  lng: number = -7.5561412;
  latOriginal: number = this.lat;
  lngOriginal: number = this.lng;
  zoom: number = 12;
  searchPlace: any;
  direccionCompleta: any;

  addressData: any = {};

  etiqueta: string = "";
  identificador: string = "";
  file: File | undefined;
  imageUrl: string | ArrayBuffer | null = null;
  showImageErrorMessage: boolean = false;
  establishmentData: any = []; //Información de los establecimientos y dispositivos
  errorMessage : string =""; //Mensaje de error
  currentPath: string = ""; //Ruta actual
  establecimientoId: number = 0; //Id del dispositivo que está en la ruta
  establecimientoActual: any = []; //Dispositivos que estamos editando
  est_img_path: string = "";
  usuarioEmail: string = "";
  establecimientoDispositivos: any = [];
  numeroDispositivos: number = 0;
  pageSizeOptions: number[] = [5, 10, this.numeroDispositivos];
  errorFinalMessage: string = "";
  errorFinal: boolean = false;
  establecimientoCreado: boolean = false;
  errorEmail: boolean = false;
  contacto: string = "";
  telefonoError: boolean = false;
  address: string = "";
  tiempoEsperaRecarga: number = 60000;
  showEtiquetaError: boolean = false;
  showIdentificadorError: boolean = false;
  waitAfterSave: boolean = false;
  formData : FormData = new FormData();
  reader = new FileReader();
  base64Image: string = "";

  clientsData: any = [];
  clientes: Clientes[] = [
  ];
  selectedCliente: number | undefined;

  signin: FormGroup = new FormGroup({
    contacto: new FormControl(''),
    telefono: new FormControl(''),
    email: new FormControl('', [Validators.email]),
  });

  estado: Estados[] = [
    {value: 0, name: 'Desactivado'},
    {value: 1, name: 'Activado'}
  ];
  selectedEstado: number =  1;

  dataSource :any;
  displayedColumns: string[] = ['dev_reference', 'dev_label', 'dev_create_at','operaciones'];

  cervezas: Cervezas[] = []
  cervezasControl: FormControl = new FormControl();
  map: any; 
  marker: any;
  userData: any = [];
  nonce: any;

  //Subscriptions
  private establishmentSubscription: Subscription | undefined;
  private beerTypesSubscription: Subscription | undefined;
  private clientsSubscription: Subscription | undefined;

  @Input() userId: any;
  
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild('search') searchElementRef: ElementRef | undefined;

  constructor(private deviceService: DeviceService, private router: Router, private userDataService: UserDataService,
    private formBuilder: FormBuilder, private userService: UserService, private error429: Error429Service,
    private mapService: MapService, private cdr: ChangeDetectorRef, @Inject(CSP_NONCE) private cspNonce: string,
    private toastr: ToastrService){
    this.currentPath = this.router.url;
    this.userData = this.userDataService.getUserData();
    this.nonce= cspNonce;
  }

  ngAfterViewInit(): void {
    //Clientes
    this.clientsSubscription = this.userService.getClients().subscribe({
      next:resp =>{
        for(let i=0; i<resp.length; i++){
          this.clientsData.push(resp[i]);
          this.clientes.push({
            value: resp[i].id,
            name: resp[i].razon_social
          });
        }
      },error:err =>{
        if (err.status == 429) {
          this.errorMessage = "Se han mandado demasiadas peticiones, espere un momento por favor";
          this.recargarPaginaDespuesDeTiempo();
        } else {
          this.errorMessage = err.error.message;
        }
      }, complete:()=>{
        this.mapService.loadMapScript(this.initMap.bind(this));
      }
    });
    //Conseguir el id del establecimiento del path
    this.establecimientoId = this.getDeviceIdFromCurrentPath(this.router);
  }
  
  initMap(){
      const mapElement = document.getElementById('map');
      // Verificar si el elemento existe antes de intentar trabajar con él
      if (mapElement) {
        const mapOptions = {
          center: { lat: this.lat, lng: this.lng },
          zoom: this.zoom,
        };
        this.map = new google.maps.Map(mapElement, mapOptions);
        this.marker = new google.maps.Marker({
          position: { lat: this.lat, lng: this.lng },
          map: this.map,
          draggable: true,
          title: 'Marcador'
        });
        this.map.addListener('click', (event:any) => {
          this.handleMapClick(event);
        });
        // Escuchar el evento 'dragend' del marcador
        this.marker.addListener('dragend', () => {
          const newPosition = this.marker.getPosition();
          this.lat = newPosition.lat();
          this.lng = newPosition.lng();
          // Actualizar la dirección cuando las coordenadas cambian
          this.getAddress(this.lat, this.lng);
        });
      } else {
        console.error('Elemento del mapa no encontrado en el DOM.');
      }
      this.getAddress(this.lat, this.lng);
      //Cargar los datos cuando se cambia la ubicación en la barra de busqueda
      const inputElement = document.getElementById('pac-input') as HTMLInputElement;
      const autocomplete = new google.maps.places.Autocomplete(inputElement);
  
      autocomplete.addListener('place_changed', () => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();
  
        if (place.geometry && place.geometry.location) {
          this.lat = place.geometry.location.lat();
          this.lng = place.geometry.location.lng();
          //Cuando se cambia la lat y lng al buscar se vuelve a cambiar el adress
          this.getAddress(this.lat, this.lng);
          this.marker.setPosition({ lat: this.lat, lng: this.lng });
          this.map.setCenter({ lat: this.lat, lng: this.lng });
        } else {
          this.toastr.error("No hay resultados", 'Error', {
            timeOut: 3500,
            progressBar: true,
            titleClass: 'toast-family-font'
          });
        }
      });
  }

  handleMapClick(event: any) {
    // Obtener las coordenadas del clic
    const clickedLat = event.latLng.lat();
    const clickedLng = event.latLng.lng();
    // Actualizar la posición del marcador
    this.lat = clickedLat;
    this.lng = clickedLng;
    this.getAddress(this.lat, this.lng);
    this.marker.setPosition({ lat: clickedLat, lng: clickedLng });
  }

  //Función para devolver "" en vez de undefined
  getValue(value: string | undefined): string {
    if (value !== undefined) {
      return value;
    }
    return "";
  }

  updateEstadoErrorEtiqueta() {
    if (!this.etiqueta) {
        this.showEtiquetaError = true;
    } else {
        this.showEtiquetaError = false;
    }
  }

  //Funciones para actualizar la página actual despues de un tiempoEsperaRecarga
  recargarPaginaDespuesDeTiempo() {
    this.error429.setError(true);
    window.location.reload();
  }

  get contactoInput() { 
    return this.signin.get('contacto'); 
  }
  get telefonoInput() { 
    return this.signin.get('telefono'); 
  }
  get emailInput() { 
    return this.signin.get('email'); 
  }

  clearField(fieldName: string) {
    this.signin.get(fieldName)?.setValue('');
  }

  ngOnDestroy(): void {
    if (this.establishmentSubscription) {
      this.establishmentSubscription.unsubscribe();
    } 
    if (this.beerTypesSubscription) {
      this.beerTypesSubscription.unsubscribe();
    } 
    if (this.clientsSubscription) {
      this.clientsSubscription.unsubscribe();
    } 
  }

  //Función para buscar en la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getDeviceIdFromCurrentPath(router: Router): number {
    const urlTree = router.parseUrl(router.url);
    const segments: UrlSegment[] = urlTree.root.children['primary'].segments;
    // Buscamos el segmento que contiene el número
    let deviceId: number | null = null;
    for (const segment of segments) {
      const value = parseInt(segment.path, 10);
      if (!isNaN(value)) {
        deviceId = value;
        break;
      }
    }
    return deviceId || 0;
  }

  getAddress(latitude: number, longitude: number) {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ location: {lat: latitude, lng: longitude} }).then((response) => {
      // La posición 0 es el lugar más cercano al click
      if (response.results[0]) {
        console.log(response);
        const addressComponents = response.results.flatMap(result => result.address_components);
        // Llama a la función para extraer y guardar los valores de los componentes
        this.addressData = this.extractAddressData(addressComponents);
        if (this.addressData.route && this.addressData.street_number) {
          this.address = `${this.addressData.route}, ${this.addressData.street_number}`;
        } else if (this.addressData.route) {
          this.address = this.addressData.route;
        } else if (this.addressData.street_number) {
          this.address = this.addressData.street_number;
        } else {
          this.address = '';
        }
        //console.log('Address Data:', this.addressData);
        this.cdr.detectChanges();
      } else {
        this.toastr.error("No hay resultados", 'Error', {
          timeOut: 3500,
          progressBar: true,
          titleClass: 'toast-family-font'
        });
      }
      console.log(this.addressData);
    });
  }

  // Función para extraer y guardar los valores de los componentes
  extractAddressData(addressComponents: google.maps.GeocoderAddressComponent[]): any {
    const data: any = {};
    for (const component of addressComponents) {
      for (const type of component.types) {
        // Verificar si el tipo ya existe en data y si no, agregarlo
        if (!data[type]) {
          data[type] = component.long_name;
        }
      }
    }
    return data;
  }

  //Cuando se cambia la ubicación en el mapa
  onChoseLocation(event: any){
    this.lat = event.coords.lat;
    this.lng = event.coords.lng;
    this.getAddress(this.lat, this.lng);
  }

  //Cuando se cambian la latitud o longitud manualmente
  updateLocation() {
    this.getAddress(this.lat, this.lng);
    this.marker.setPosition({ lat: this.lat, lng: this.lng });
    this.map.setCenter({ lat: this.lat, lng: this.lng });
  }

  refresh() {
    this.lat = this.latOriginal;
    this.lng = this.lngOriginal
    this.getAddress(this.lat, this.lng);
    this.marker.setPosition({ lat: this.lat, lng: this.lng });
    this.map.setCenter({ lat: this.lat, lng: this.lng });
  }

  onFileSelected(event: any) {
    //this.file = (event.target as HTMLInputElement).files[0];
    this.file = event.target.files[0];
    if (this.file && this.file !==undefined && this.file.type === 'image/jpeg') {
      this.previewImage();
      this.showImageErrorMessage = false;
      this.formData.append('img', this.file as Blob);
    } else {
      this.imageUrl = null;
      this.showImageErrorMessage = true;
    }
    if(this.file == undefined){
      this.showImageErrorMessage = false;
    }
  }

  previewImage() {
    this.reader.onload = () => {
      this.imageUrl = this.reader.result;
      /*if (typeof this.reader.result === 'string') {
        this.base64Image = this.reader.result.split(',')[1];
        console.log(this.base64Image);
      }*/
    };
    this.reader.readAsDataURL(this.file as Blob);
  }

  get isPhoneNumberValid(): boolean {
    const phoneControl = this.telefonoInput;
    const phoneNumber = phoneControl?.value;
    // Si el número de teléfono está vacío, considerarlo válido
    if (!phoneNumber || phoneNumber.trim() === '') {
      return true;
    }
    const mask = '000 00 00 00'; // Formato utilizado en ngx-mask
    const requiredLength = mask.replace(/[^0]/g, '').length;
    
    return phoneNumber.replace(/[^0-9]/g, '').length === requiredLength;
  }

  guardarDispositivo() {
    if (this.identificador == "") {
      this.showIdentificadorError = true;
    } else {
      this.showIdentificadorError = false;
    }
    //Comprobar si falta por añadir una etiqueta
    if (this.etiqueta == "") {
      this.showEtiquetaError = true;
    } else {
      this.showEtiquetaError = false;
    }
    //No se verifica si el email existe, sino que tenga formato email
    if (this.emailInput?.valid) {
      this.errorEmail = false;
    } else {
      this.errorEmail = true;
    }
    //Error teléfono invalido o vacio
    if(this.isPhoneNumberValid){
      this.telefonoError = false;
    } else {
      this.telefonoError = true;
    }

    if(!this.telefonoError && !this.errorEmail && !this.showImageErrorMessage && !this.showEtiquetaError && !this.showIdentificadorError){
      /*console.log(this.formData.getAll("img"));
      let establecimiento = {
        _method: "PUT", 
        img: this.formData.getAll("img"),
        name: this.etiqueta,
        beertypes: this.cervezasControl.value,
        contacto: this.contactoInput?.value,
        telefono: this.telefonoInput?.value,
        email: this.emailInput?.value,
        address: this.address,
        localidad: this.getValue(this.addressData.locality),
        provincia:this.getValue(this.addressData.administrative_area_level_2), 
        ccaa: this.getValue(this.addressData.administrative_area_level_1),
        pais: this.getValue(this.addressData.country),
        cp: this.getValue(this.addressData.postal_code),
        lat: this.lat,
        lng: this.lng,
        cliente_id: this.selectedCliente,
        status: this.selectedEstado
      };*/
      const locality = this.addressData.locality ? this.getValue(this.addressData.locality): this.addressData.sublocality
        ? this.getValue(this.addressData.sublocality): this.addressData.sublocality_level_1
          ? this.getValue(this.addressData.sublocality_level_1): '';
      //Necesitamos meterlo en un formData para meter la imagen
      const establecimientoData = new FormData();
      establecimientoData.append('_method', "PUT");
      establecimientoData.append('img', this.file as Blob);
      establecimientoData.append('name', this.etiqueta);
      establecimientoData.append('beertypes', JSON.stringify(this.cervezasControl.value));
      establecimientoData.append('contacto', this.contactoInput?.value || '');
      establecimientoData.append('telefono', this.telefonoInput?.value || '');
      establecimientoData.append('email', this.emailInput?.value || '');
      establecimientoData.append('address', this.address);
      establecimientoData.append('localidad', locality);
      establecimientoData.append('provincia', this.getValue(this.addressData.administrative_area_level_2));
      establecimientoData.append('ccaa', this.getValue(this.addressData.administrative_area_level_1));
      establecimientoData.append('pais', this.getValue(this.addressData.country));
      establecimientoData.append('cp', this.getValue(this.addressData.postal_code));
      establecimientoData.append('lat', this.lat.toString());
      establecimientoData.append('lng', this.lng.toString());
      establecimientoData.append('cliente_id', this.selectedCliente?.toString() || '');
      establecimientoData.append('status', this.selectedEstado.toString());
      establecimientoData.append('external_id', this.identificador);

      this.establishmentSubscription = this.deviceService.createEstablishment(establecimientoData).subscribe({
        next:resp => {
        }, error: err =>{
          this.errorMessage = err.error.message;
          console.log(this.errorMessage);
          if(this.errorMessage == undefined){
            this.errorMessage = err.error.error;
            console.log(this.errorMessage);
          }
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.errorFinal = true;
            setTimeout(() => {
              this.errorFinal = false;
              this.waitAfterSave = false;
            },3500)
          }
        }, complete: () =>{
          if (!this.waitAfterSave) {
            this.waitAfterSave = true;
            this.establecimientoCreado=true;
            setTimeout(() => {
              this.file = undefined;
              this.imageUrl = null;
              this.etiqueta = "";
              this.identificador = "",
              this.cervezasControl.setValue([]);
              this.signin.setValue({
                contacto: '',
                telefono: '',
                email: '',
              });
              this.errorEmail = false;
              this.lat = 43.0081016;
              this.lng = -7.5561412;
              this.getAddress(this.lat, this.lng);
              this.selectedCliente = undefined;
              this.selectedEstado = 1;
              this.waitAfterSave = false;
              this.establecimientoCreado = false;
            }, 3500);
          }      
        }
      })
    }
    
    /*console.log('Imagen: ', this.file);
    console.log('Valor de etiqueta: ', this.etiqueta);
    console.log('Tipos de cerveza seleccionados:', this.cervezasControl.value);
    console.log('Contacto: ', this.contactoInput?.value);
    console.log('Teléfono: ', this.telefonoInput?.value);
    console.log('Email: ',this.emailInput?.value);
    console.log('address: ',this.address);
    console.log('Localidad: ', this.getValue(this.addressData.locality));
    console.log('Provincia: ', this.getValue(this.addressData.administrative_area_level_2));
    console.log('CCAA: ', this.getValue(this.addressData.administrative_area_level_1));
    console.log('Pais: ', this.getValue(this.addressData.country));
    console.log('CP: ', this.getValue(this.addressData.postal_code));
    console.log('Latitud = ', this.lat);
    console.log('Longitud = ', this.lng);
    console.log('Cliente ID: ', this.selectedCliente);
    console.log('Estado: ', this.selectedEstado);

    console.log('---------------------------');

    console.log(this.showImageErrorMessage);

    //Cuando se guardan los cambios hay que actualizar el valor de updated_at

    console.log('---------------------------------------');*/
  }

}
